<template>
  <div class="p-4">
    <!-- 搜索表单 -->
    <div class="search-form-wrapper">
      <div class="search-form">
        <div class="search-item">
          <label>标签:</label>
          <el-input v-model="searchText" placeholder="请输入标签" clearable @keyup.enter.native="handleSearch"
            @clear="handleClear" style="width: 200px"></el-input>
        </div>
        <div class="search-buttons">
          <el-button @click="handleClear">清空</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button type="primary" @click="addTagAction">
            新增标签
          </el-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="mt-5">
      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <div class="global-body-wrap">
          <appTable :tableProps="tableProps" :tableData="formattedTableData" :selectCtrl="false" :orderCtrl="true"
            :currentPage="params.page" :pageSize="params.pageSize" @tableHandle="tableHandle" />
        </div>
        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <pagination :currentPage="params.page" :pageSize="params.pageSize" :total="total" @pageNum="getPageNum" />
        </div>
      </el-card>
    </div>

    <!-- 标签编辑对话框 -->
    <el-dialog :title="tagDetails ? '编辑标签' : '新增标签'" :visible.sync="dialogVisible" width="500px"
      @close="handleTagDialogClose">
      <el-form :model="formData" :rules="rules" ref="tagForm" label-width="100px">
        <!-- 按一个字段校验三种语言，在同一处展示提示，校验规则参考 galaxy -->
        <el-form-item label="标签" prop="name">
          <div class="name-inputs">
            <div class="name-input-item">
              <span class="name-label">简体:</span>
              <el-input v-model="formData.nameZh" placeholder="请输入简体标签" class="name-input"></el-input>
            </div>
            <div class="name-input-item">
              <span class="name-label">繁体:</span>
              <el-input v-model="formData.nameTw" placeholder="请输入繁体标签" class="name-input"></el-input>
            </div>
            <div class="name-input-item">
              <span class="name-label">英文:</span>
              <el-input v-model="formData.nameEn" placeholder="请输入英文标签" class="name-input"></el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleTagDialogConfirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 操作详情对话框 -->
    <el-dialog title="操作详情" :visible.sync="optRecordVisible" width="80%" fullscreen>
      <opt-record :detailId="detailId" />
    </el-dialog>
  </div>
</template>

<script>
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
import OptRecord from "./components/optRecord/index.vue";
import api from "@/api";
import { valueByLanguage, createLanguageData } from "@/utils/college";

export default {
  name: "TagManagement",
  components: {
    appTable,
    pagination,
    OptRecord
  },
  mixins: [listMixin],
  data() {
    return {
      params: {
        page: 1,
        pageSize: 20
      },
      searchText: "",
      tableData: [],
      total: 0,
      dialogVisible: false,
      optRecordVisible: false,
      detailId: null,
      tagDetails: null,
      formData: {
        nameZh: "",
        nameTw: "",
        nameEn: ""
      },
      rules: {
        // 在一个字段上统一校验三种语言名称，并根据缺失语言给出不同提示
        name: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const { nameZh, nameTw, nameEn } = this.formData || {};
              if (!nameZh || !nameZh.trim()) {
                callback(new Error("请输入简体标签"));
              } else if (!nameTw || !nameTw.trim()) {
                callback(new Error("请输入繁体标签"));
              } else if (!nameEn || !nameEn.trim()) {
                callback(new Error("请输入英文标签"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    tableProps() {
      return [
        {
          prop: "id",
          label: "标签ID"
        },
        {
          prop: "nameZh",
          label: "标签（简体）"
        },
        {
          prop: "nameTw",
          label: "标签（繁体）"
        },
        {
          prop: "nameEn",
          label: "标签（英文）"
        },
        {
          prop: "handle",
          label: "操作",
          width: 200,
          btn: ["编辑", "操作详情"]
        }
      ];
    },
    // 处理表格数据，添加格式化后的字段
    formattedTableData() {
      return this.tableData.map((row) => {
        if (!row || !row.id) {
          return row;
        }
        return {
          ...row,
          // 保留原始的 name 字段，用于编辑功能
          // 使用 returnValue=true 获取字符串值用于显示
          nameZh: this.getValueByLanguage(row.name, "zh_CN", true) || "-",
          nameTw: this.getValueByLanguage(row.name, "zh_TW", true) || "-",
          nameEn: this.getValueByLanguage(row.name, "en", true) || "-"
        };
      });
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      api
        .getMaterialTagList(this.params)
        .then((res) => {
          this.tableData = res.data.items || [];
          this.total = res.data.count || 0;
        })
        .catch((err) => {
          this.$message.error(err.message || "获取列表失败");
        });
    },
    handleSearch() {
      this.params = {
        page: 1,
        pageSize: 20
      };
      if (this.searchText) {
        this.params.text = this.searchText;
      }
      this.getList();
    },
    handleClear() {
      this.searchText = "";
      this.params = {
        page: 1,
        pageSize: 20
      };
      this.getList();
    },
    getPageNum(page) {
      this.params.page = page;
      this.getList();
    },
    tableHandle(data) {
      // appTable 传递的是 { type, data: scope }，其中 scope 包含 row
      const row = data.data && data.data.row ? data.data.row : data.row;

      if (data.type === "编辑") {
        // 确保 row 存在且有 id
        if (row && row.id) {
          this.updateTagAction(row);
        } else {
          console.error("编辑失败：行数据无效", data, row);
        }
      } else if (data.type === "操作详情") {
        if (row && row.id) {
          this.openOptRecord(row);
        } else {
          console.error("操作详情失败：行数据无效", data, row);
        }
      }
    },
    addTagAction() {
      this.tagDetails = null;
      this.formData = {
        nameZh: "",
        nameTw: "",
        nameEn: ""
      };
      this.dialogVisible = true;
    },
    updateTagAction(item) {
      if (!item || !item.id) {
        console.error("updateTagAction: item 无效", item);
        return;
      }

      // 从 tableData 中查找原始数据，因为 formattedTableData 可能没有原始的 name 字段
      const originalItem = this.tableData.find(row => row && row.id === item.id);

      if (!originalItem) {
        console.error("updateTagAction: 找不到原始数据", item.id);
        return;
      }

      this.tagDetails = originalItem;
      const name = originalItem.name || [];
      this.formData = {
        nameZh: this.getValueByLanguage(name, "zh_CN", true) || "",
        nameTw: this.getValueByLanguage(name, "zh_TW", true) || "",
        nameEn: this.getValueByLanguage(name, "en", true) || ""
      };
      this.dialogVisible = true;
    },
    handleTagDialogConfirm() {
      this.$refs.tagForm.validate((valid) => {
        if (valid) {
          const name = createLanguageData(
            this.formData.nameZh,
            this.formData.nameTw,
            this.formData.nameEn
          );
          const params = { name };

          if (this.tagDetails) {
            api
              .updateMaterialTag(this.tagDetails.id, params)
              .then(() => {
                this.$message.success("更新成功");
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err.message || "更新失败");
              });
          } else {
            api
              .addMaterialTag(params)
              .then(() => {
                this.$message.success("创建成功");
                this.dialogVisible = false;
                this.getList();
              })
              .catch((err) => {
                this.$message.error(err.message || "创建失败");
              });
          }
        }
      });
    },
    handleTagDialogClose() {
      this.tagDetails = null;
      this.formData = {
        nameZh: "",
        nameTw: "",
        nameEn: ""
      };
    },
    openOptRecord(row) {
      if (!row || !row.id) {
        console.error("openOptRecord: row 无效", row);
        return;
      }
      this.detailId = row.id;
      this.optRecordVisible = true;
    },
    getValueByLanguage(data, locale, returnValue = false) {
      return valueByLanguage(data, locale, returnValue);
    }
  }
};
</script>

<style scoped>
.search-form-wrapper {
  /* margin-bottom: 20px; */
  padding: 20px;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-item label {
  white-space: nowrap;
}

.search-buttons {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.name-inputs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.name-input-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.name-label {
  width: 50px;
  white-space: nowrap;
  font-size: 14px;
}

.name-input {
  flex: 1;
}
</style>
